var map = {
	"./common/viewApplyBook.dialog.js": "c2d3",
	"./manager/modifyPassword.dialog.js": "14c0",
	"./object/addApi.dialog.js": "4dda",
	"./object/addObject.dialog.js": "fc21",
	"./student/modifyStudent.dialog.js": "9a90",
	"./teacher/modifyTeacher.dialog.js": "8fd9",
	"./teacher/viewNominateStudent.dialog.js": "3770",
	"./works/workViewer.dialog.js": "0887"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c4a";